export interface Breadcrumb {
  label: string
  href?: string
}

export const SIDEBAR_COLLAPSED_WIDTH = 4
export const SIDEBAR_EXPANDED_WIDTH = 16
export const RIGHT_PANEL_WIDTH = 32

const SIDEBAR_KEY = 'design:sidebarExpanded'

export const useAppLayout = () => {
  const isSidebarExpanded = useState('design:sidebarExpanded', () => {
    if (import.meta.client) {
      const saved = localStorage.getItem(SIDEBAR_KEY)
      if (saved !== null) return saved === 'true'
    }
    return false
  })

  watch(isSidebarExpanded, (v) => {
    if (import.meta.client) localStorage.setItem(SIDEBAR_KEY, String(v))
  })
  const isRightPanelOpen = useState('design:rightPanelOpen', () => false)
  const rightPanelTitle = useState('design:rightPanelTitle', () => 'Panel')
  const breadcrumbs = useState<Breadcrumb[]>('design:breadcrumbs', () => [])

  return {
    isSidebarExpanded,
    isRightPanelOpen,
    rightPanelTitle,
    breadcrumbs,
    toggleSidebar: () => { isSidebarExpanded.value = !isSidebarExpanded.value },
    openRightPanel: (title?: string) => {
      if (title) rightPanelTitle.value = title
      isRightPanelOpen.value = true
    },
    closeRightPanel: () => { isRightPanelOpen.value = false },
    toggleRightPanel: (title?: string) => {
      if (title) rightPanelTitle.value = title
      isRightPanelOpen.value = !isRightPanelOpen.value
    },
    setBreadcrumbs: (crumbs: Breadcrumb[]) => { breadcrumbs.value = crumbs },
  }
}
